import { CheckCircle } from 'lucide-react';

const SuccessNotification = ({ message, onDismiss }) => {
  if (!message) return null;

  return (
    <div className="fixed top-4 right-4 z-[300] max-w-md animate-fadeIn">
      <div className="bg-green-900/20 border border-green-500/50 rounded-lg p-4 backdrop-blur-sm">
        <div className="flex items-start gap-3">
          <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-gray-300 text-sm">{message}</p>
          </div>
          <button
            onClick={onDismiss}
            className="text-gray-400 hover:text-white transition-colors text-xl leading-none"
            aria-label="Dismiss notification"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessNotification;